<template>
    <div class="search-fields">
        <div class="first-col">
            <div class="form-group">
                <div class="drop-hold">
                    <input
                        type="search"
                        autocomplete="off"
                        placeholder="Search"
                        name="country_name"
                        id="searchByName"
                        class="form-control"
                        v-model="countryName"
                        @input="searchCountry"
                    >
                    <div
                        :style="[d_none_names ? {'margin' : '0px', 'border': '0px'} : {'margin': '0px', 'border': '0px'}]"
                        :class="['drop', {'d-none': d_none_names}]"
                        v-if="countryName"
                        v-click-outside="closeCountryList"
                    >
                        <ul>
                            <li v-for="country in countries" @click="selectCountry(country)" @touch="selectCountry(country)">{{ country.name }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="second-col">
            <div class="form-group drop-hold">
                <input
                    type="search"
                    autocomplete="off"
                    name="color"
                    placeholder="Color codes"
                    id="searchByColor"
                    :class="['custom-select', {'opened-select': selectOpened}]"
                    v-model="selectedColor"
                >
                <div :class="['drop', {'d-none': d_none_colors}]" v-click-outside="closeColorList">
                    <ul>
                        <li
                            class="d-flex justify-content-start"
                            v-for="color in input_colors"
                            @click="selectColor(color.name)"
                        >
                            <div class="img-dot" :style="colorImage(color.color)"></div>
                            <p>{{ colorName(color.name) }}</p>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
        <div class="btn-hold">
            <button type="submit" class="btn btn-secondary" @click="search()">Search</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            input_countries: Array,
            input_type: String,
            input_colors: Array
        },
        data() {
            return {
                countryName: null,
                selectedColor: null,
                showCountryList: false,
                d_none_names: true,
                d_none_colors: true,
                selectOpened: false,
                timeoutID: null,
                countries: this.input_countries,
            }
        },
        methods: {
            searchCountry() {
                if (this.countryName.length > 1) {
                    this.d_none_names = false;
                    this.countries = this.input_countries.filter(item =>
                        item.name.toLowerCase().includes(this.countryName.toLowerCase())
                    );
                } else {
                    this.countries = this.input_countries
                }
            },
            selectCountry(country) {
                this.countryName = country.name;
                this.countries = this.input_countries
                this.d_none_names = true
            },
            closeCountryList(e) {
                if (e.target.id === 'searchByName') {
                    this.d_none_names = false;
                } else {
                    if (this.countries && this.countries.length) this.d_none_names = true;
                }
            },
            selectColor(color) {
                this.selectedColor = this.colorName(color);
                this.d_none_colors = true;
                this.selectOpened = false;
            },
            closeColorList(e) {
                if (this.input_colors && this.input_colors.length) {
                    this.d_none_colors = e.target.id !== 'searchByColor';
                    this.selectOpened = e.target.id === 'searchByColor';
                }
            },
            search() {
                let url = '';

                if (this.input_type === 'executive'){
                    url = (this.countryName ? '/executive-digest/' + (this.countryName ? this.countryName.toLowerCase() : '' )  : '/executive-digest') + '?color_code=' + (this.selectedColor ? this.selectedColor.toLowerCase() : '' )
                } else if (this.input_type === 'country') {
                    url = '/world-guide/country?country_name=' + (this.countryName ? this.countryName.toLowerCase() : '' ) + '&color_code=' + (this.selectedColor ? this.selectedColor.toLowerCase() : '' )
                } else if (this.input_type === 'city') {
                    url = '/world-guide/city?city_name=' + (this.countryName ? this.countryName.toLowerCase() : '' ) + '&color_code=' + (this.selectedColor ? this.selectedColor.toLowerCase() : '' )
                } else if (this.input_type === 'risk-rating') {
                    url = '/world-guide/country?country_name=' + (this.countryName ? this.countryName.toLowerCase() : '' ) + '&color_code=' + (this.selectedColor ? this.selectedColor.toLowerCase() : '' )
                }

                location.href = url
            },
            colorImage(color) {
                if (color.toLowerCase() === 'amber') {
                    return `background-color: #ffbf00`
                }

                return `background-color: ${color.toLowerCase()}`
            },
            colorName(color) {
                return color.charAt(0).toUpperCase() + color.slice(1)
            }
        }
    }
</script>

<style lang="less">
    @import "../../../../../../resources/less/includes/variables";

    .custom-select {
      transition: background 2s ease-in-out .5s;

      &.opened-select {
        background: url(/images/chevron-up.svg) no-repeat right 0.75rem center;
        background-size: 0.65rem auto;
      }
    }

    .drop-hold {
      position: relative;
      width: 100%;

      .drop {
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
        border: 1px solid #dadada;
        background: @white;
        .margin(1, 0, 0, 0);
        max-height: 12.5rem;
        overflow: auto;
        z-index: 100;

        ul {
          margin: 0;
          list-style: none;

          li {
            .padding(5, 10, 5, 14);
            .font-size(15);

            .img-dot {
              height: 10px;
              width: 10px;
              border-radius: 50%;
              display: inline-block;
              margin-top: 5px;
            }

            p {
              margin: 0;
            }

             &:hover {
               background: #f0f0f0;
               color: @black;
               font-weight: bold;
             }
          }
        }
      }
    }

    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
      -webkit-appearance:none;
    }
</style>
